import React from 'react';
import Popup from 'reactjs-popup';
import type { PopupPosition } from 'reactjs-popup/dist/types';

type TooltipChildren =
	| React.ReactNode
	| ((close: () => void) => React.ReactNode);

interface TooltipProps {
	trigger?: React.ReactNode;
	position?: PopupPosition;
	children?: TooltipChildren;
	customStyle?: React.CSSProperties;
	isOpen?: boolean;
	disableHover?: boolean;
}

const PopupAny = Popup as unknown as React.ComponentType<any>;

export default function Tooltip({
	trigger,
	position,
	customStyle,
	children,
	isOpen = false,
	disableHover = false,
}: TooltipProps) {
	const contentStyle: React.CSSProperties = {
		background: '#062a60',
		padding: '8px 6px',
		fontSize: 12,
		fontFamily: 'Rubik',
		color: '#fff',
		borderRadius: 4,
		maxWidth: 300,
		textAlign: 'center',
	};

	const arrowStyle: React.CSSProperties = { color: '#062a60' };

	return (
		<PopupAny
			open={isOpen}
			modal={false}
			trigger={<div style={customStyle}>{trigger}</div>}
			position={position}
			on={disableHover ? undefined : 'hover'}
			contentStyle={contentStyle}
			arrowStyle={arrowStyle}>
			{(close: () => void) =>
				typeof children === 'function' ? children(close) : children
			}
		</PopupAny>
	);
}
